import { Box } from 'components/Box';
import { AnchorButton } from 'components/Button/AnchorButton';
import { H2 } from 'components/Text/H2';
import { CmsApiRandomGradProgramsBlockData } from 'modules/cms/api/types/blocks/CmsApiRandomGradProgramsBlock';
import { colors, gutterWidth } from 'theme';
import { listingSearchHomePath } from 'utils/searchHomePages';

import { CmsAmpRandomGradProgramsBlockPrograms } from './CmsAmpRandomGradProgramsBlockPrograms';

type Props = {
  data: CmsApiRandomGradProgramsBlockData;
};

export function CmsAmpRandomGradProgramsBlock({ data: { headline } }: Props) {
  return (
    <Box
      mx={[-gutterWidth / 2, null, -gutterWidth]}
      p={[gutterWidth / 2, null, gutterWidth]}
      borderRadius={[0, null, null, 48]}
      bg={colors.backgroundGrey}
      textAlign="center"
    >
      {headline && <H2>{headline}</H2>}
      <AnchorButton href={`${listingSearchHomePath('GRAD_PROGRAM')}?q=`}>
        {getText('See All')}
      </AnchorButton>
      <Box mt={48}>
        <CmsAmpRandomGradProgramsBlockPrograms />
      </Box>
    </Box>
  );
}
